import type { TrackedLine } from "@workspace/analytics"

/**
 * Add-to-cart action result shared between the Server Actions (`./actions.ts`)
 * and the client form that drives them via `useActionState`
 * (`../menu/[itemId]/add-to-cart-form.tsx`). Kept OUT of the `"use server"`
 * actions file on purpose: a `"use server"` module may only export async
 * functions, so a plain `const`/`type` has to live in an ordinary module.
 *
 * `count` is the item's post-add total quantity in the cart (for the toast /
 * the "N in cart" indicator). `tracked` is the added line, priced by the
 * engine, for the GA4 `add_to_cart` event — absent when pricing it failed
 * (which never fails the add itself).
 */
export type AddToCartState =
  | { status: "idle" }
  | { status: "added"; itemId: string; count: number; tracked?: TrackedLine }
  | {
      status: "error"
      error:
        | "sold_out"
        | "not_found"
        | "order_type_unavailable"
        | "not_available_now"
        | "selection_incomplete"
    }

export const ADD_TO_CART_IDLE: AddToCartState = { status: "idle" }
